export var UrlHelper = {
    getUrl: function (url, base) {
        var urlInstance = new URL(base);
        var parts = url.split("?");
        var pathname = parts[0];
        if (pathname !== "/" && pathname.length > 0) {
            if (urlInstance.pathname.endsWith("/")) {
                urlInstance.pathname = urlInstance.pathname.slice(0, -1);
            }
            urlInstance.pathname += "".concat(pathname.startsWith("/") ? "" : "/").concat(pathname);
        }
        var search = parts[1];
        if (search) {
            urlInstance.search = search;
        }
        urlInstance.href = urlInstance.href.replace(/([^:]\/)\/+/g, "$1");
        return urlInstance;
    },
    changeUrlParam: function (key, value) {
        var params = new URLSearchParams(window.location.search);
        params.set(key, value);
        var newUrl = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(params.toString());
        window.history.pushState({ path: newUrl }, "", newUrl);
    },
    getUrlParam: function (key) {
        var params = new URLSearchParams(window.location.search);
        return params.get(key);
    },
    removeUrlParam: function (key) {
        var params = new URLSearchParams(window.location.search);
        params.delete(key);
        var newUrl = "".concat(window.location.origin).concat(window.location.pathname, "?").concat(params.toString());
        window.history.pushState({ path: newUrl }, "", newUrl);
    },
    isValidUrl: function (text) {
        var pattern = new RegExp("^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$", "i"); // fragment locator
        return pattern.test(text);
    },
    getUrlWithoutProtocol: function (url) {
        return url.replace(/(^\w+:|^)\/\//, "");
    },
    openPopup: function (url, windowWidth, windowHeight) {
        if (windowWidth === void 0) { windowWidth = 500; }
        if (windowHeight === void 0) { windowHeight = 700; }
        //@ts-ignore
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
        //@ts-ignore
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
        var width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
        var height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;
        var left = width / 2 - windowWidth / 2 + dualScreenLeft;
        var top = height / 2 - windowHeight / 2 + dualScreenTop;
        var title = new Date().getTime();
        var newWindow = window.open(url, title.toString(), "scrollbars=yes, width=".concat(windowWidth, ", height=").concat(windowHeight, ", top=").concat(top, ", left=").concat(left));
        if (window["focus"]) {
            newWindow.focus();
        }
        return newWindow;
    },
};
//# sourceMappingURL=url.helper.js.map